import Button from '../common/Button';

function ContactCtaSection() {
  return (
    <section className="section contact-cta-section" id="contact">
      <div className="container contact-cta">
        <div>
          <p className="eyebrow">Contact</p>
          <h2>Start a conversation with FactorStreet</h2>
          <p>
            For business, project, partnership, or collaboration inquiries, connect with the
            FactorStreet team.
          </p>
          <a className="contact-email" href="mailto:hello@factorstreet.com">
            hello@factorstreet.com
          </a>
        </div>
        <Button to="/contact">Contact Us</Button>
      </div>
    </section>
  );
}

export default ContactCtaSection;
